import { allowedFilters } from '@/store/modules/admin/tarfinProQuotation'

import i18n from '@/i18n/i18n'
import TarfinProQuotationService from '@/services/retailer/TarfinProQuotationService'
import { build_query, errorMessage } from '@/utilities/helpers'

import { TARFIN_PRO_QUOTATION_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const allowedIncludes = 'items,items.product'

export const allowedSorts = '-created_at'

export const allowedAppends = ''

export const namespaced = true

export const state = {
  categories: null,
  quotations: null,
  topQuotations: null,
  quotation: null,
  meta: null,
  document: null,
  qrCode: null,
  maturityOptions: [],
  showStepsDocumentWaitingPage: true,
  signedDocument: null,
  originalDocument: null
}

export const mutations = {
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  SET_QUOTATIONS(state, quotations) {
    state.quotations = quotations.data
    state.meta = quotations.meta
  },
  SET_TOP_QUOTATIONS(state, quotations) {
    state.topQuotations = quotations.data
  },
  SET_QUOTATION(state, quotation) {
    state.quotation = quotation.data
  },
  SET_DOCUMENT(state, document) {
    state.document = document
    let indexOfUploadedDocument = state.quotation.documents.findIndex(quotationDocument => {
      return quotationDocument.id === document.id
    })
    state.quotation.documents[indexOfUploadedDocument] = document
  },
  SET_QR_CODE(state, qrCode) {
    state.qrCode = qrCode
  },
  SET_MATURITY_OPTIONS(state, maturity) {
    state.maturityOptions = maturity
  },
  SET_SHOW_STEPS_DOCUMENT_WAITING_PAGE(state, show) {
    state.showStepsDocumentWaitingPage = show
  },
  SET_SIGNED_DOCUMENT(state, document) {
    state.signedDocument = document
  },
  SET_ORIGINAL_DOCUMENT(state, document) {
    state.originalDocument = document
  }
}

export const actions = {
  getCategories({ dispatch, commit, state }) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.getCategories()
        .then(response => {
          commit('SET_CATEGORIES', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_QUOTATION_ERROR_MESSAGES.getCategoriesError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getQuotations({ dispatch, commit, state }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.getQuotations(newQuery)
        .then(response => {
          commit('SET_QUOTATIONS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_QUOTATION_ERROR_MESSAGES.getRequestsError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getTopQuotations({ dispatch, commit, state }, query) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.getTopQuotations()
        .then(response => {
          commit('SET_TOP_QUOTATIONS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_QUOTATION_ERROR_MESSAGES.getRequestsError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getQuotation({ dispatch, commit, state }, id) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.getQuotation(id)
        .then(response => {
          commit('SET_QUOTATION', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_QUOTATION_ERROR_MESSAGES.getRequestError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createQuotation({ dispatch, commit, state }, quotation) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.createQuotation(quotation)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('views.retailer.tarfin_pro_requests.create_request')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  acceptQuotation({ dispatch, commit, state }, quotation) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.acceptQuotation(quotation)
        .then(response => {
          commit('SET_QUOTATION', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_QUOTATION_ERROR_MESSAGES.getRequestError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  selectPaymentMethod({ dispatch, commit, state }, payload) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.selectPaymentMethod(payload.id, payload.payload)
        .then(response => {
          commit('SET_QUOTATION', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  changePaymentMethod({ dispatch, commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.changePaymentMethod(id, payload)
        .then(response => {
          commit('SET_QUOTATION', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  cancelQuotation({ dispatch, commit, state }, quotation) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.cancelQuotation(quotation)
        .then(response => {
          commit('SET_QUOTATION', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_QUOTATION_ERROR_MESSAGES.getRequestError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  cancelQuotationProduct({ dispatch, commit, state }, quotation) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.cancelQuotationProduct(quotation)
        .then(response => {
          commit('SET_QUOTATION', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_QUOTATION_ERROR_MESSAGES.getRequestsError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  restoreQuotationProduct({ dispatch, commit, state }, quotation) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.restoreQuotationProduct(quotation)
        .then(response => {
          commit('SET_QUOTATION', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_QUOTATION_ERROR_MESSAGES.getRequestError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  uploadDocument({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.uploadDocument(params.quotationId, params.documentId, params.file)
        .then(response => {
          commit('SET_QUOTATION', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  uploadDocumentFromMobile({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.uploadDocumentFromMobile(params.hash, params.documentId, params.file)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getQrCode({ dispatch, commit, state }, id) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.getQrCode(id)
        .then(response => {
          if (response && response.qr_code) {
            commit('SET_QR_CODE', 'data:image/png;base64,' + response.qr_code)
          }

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_QUOTATION_ERROR_MESSAGES.getQrCodeError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  generateMaturityOption({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.generateMaturityOption(params.id)
        .then(response => {
          commit('SET_MATURITY_OPTIONS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  sendVerifyPhoneOTPCodeProQuotation({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.sendVerifyPhoneOTPCodeProQuotation(params.id, params.phone)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.retailer.farmer.confirmation_code_sent')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.retailer.farmer.confirmation_code_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  verifyPhoneOTPCodeProQuotation({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.verifyPhoneOTPCodeProQuotation(params.code, params.id)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewOriginalDocument({ dispatch, commit }, documentId) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.viewOriginalDocument(documentId)
        .then(response => {
          commit('SET_ORIGINAL_DOCUMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewSignedDocument({ dispatch, commit }, document) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationService.viewSignedDocument(document.id, document.mime_type)
        .then(response => {
          commit('SET_SIGNED_DOCUMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
